import { ConnectButton } from "@/components/connect-button";
import {
  TransactionDialog,
  transactionInner,
} from "@/components/transaction/transaction-dialog";
import { shorten } from "@/lib/utils";
import { useWallet } from "@txnlab/use-wallet";
import { Wallet, UserRound, ChevronRight, ChevronLeft } from "lucide-react";
import { toLocaleString } from "@/lib/utils";
import { BenchStateFull } from "@myth-finance/bench-sdk";
import { decodeTransactions, getBenchInstanceClient } from "@/lib/clients";

export function CloseOutButton({
  data,
  reloadState,
  algoBalance,
  purchaseBalance,
}: {
  data: BenchStateFull;
  reloadState: () => any;
  algoBalance: number;
  purchaseBalance: number;
}) {
  const { activeAddress } = useWallet();

  const makeCloseTransactions = async () => {
    const benchSDK = getBenchInstanceClient(data.appId, data.registryAppId);
    return decodeTransactions(
      await benchSDK.makeCloseTxns({ sender: activeAddress! })
    );
  };

  return (
    <TransactionDialog
      type="purchase"
      trigger={(onClick) => (
        <ConnectButton onClick={onClick}>
          <Wallet size={18} className="mr-1.5" />
          <span>Close out bench</span>
        </ConnectButton>
      )}
      transactionBuilder={() => makeCloseTransactions()}
      title={`Closing out ${data.sellingUnitName} bench`}
      onClose={() => reloadState()}
      onSuccess={() => reloadState()}
    >
      {transactionInner(
        "operation",
        <div className="flex-col flex">
          <div className="mb-2">
            You are going to <strong>close out</strong> this bench:
          </div>
          <div>- pay out all outstanding revenue and fees</div>
          <div>- opt the bench out of all assets</div>
        </div>,
        <>
          <div className="flex justify-between gap-2 mb-2">
            <div className="flex items-center">
              <UserRound size={18} className="mr-1" /> Account
            </div>{" "}
            <span className="text-right">{shorten(activeAddress!)}</span>
          </div>

          <div className="flex justify-between gap-2 text-foreground">
            <div className="flex items-center">
              <ChevronRight size={18} className="mr-1" /> Call app: close
            </div>
            <span className="text-right">{Number(data.appId)}</span>
          </div>

          <div className="flex justify-between gap-2 mt-2">
            <div className="flex items-center">
              {shorten(data.ownerAddr)}{" "}
              <ChevronLeft size={18} className="mr-1" />
            </div>{" "}
            <span className="text-right">
              {toLocaleString(
                (purchaseBalance - data.feesAccrued) / data.purchaseDecimalDenom
              )}{" "}
              {data.purchaseUnitName}
            </span>
          </div>

          <div className="flex justify-between gap-2">
            <div className="flex items-center">
              {shorten(data.ownerAddr)}{" "}
              <ChevronLeft size={18} className="mr-1" />
            </div>{" "}
            <span className="text-right">
              {toLocaleString(algoBalance / 1e6)} ALGO
            </span>
          </div>

          {data.remainingTokens ? (
            <div className="flex justify-between gap-2">
              <div className="flex items-center">
                {shorten(data.ownerAddr)}{" "}
                <ChevronLeft size={18} className="mr-1" />
              </div>{" "}
              <span className="text-right">
                {toLocaleString(data.remainingTokens)} {data.sellingUnitName}
              </span>
            </div>
          ) : null}

          <div className="flex justify-between gap-2">
            <div className="flex items-center">
              {shorten(data.feeAddr)} <ChevronLeft size={18} className="" />{" "}
              fees
            </div>{" "}
            <span className="text-right">
              {toLocaleString(data.feesAccrued / data.purchaseDecimalDenom)}{" "}
              {data.purchaseUnitName}
            </span>
          </div>
        </>
      )}
    </TransactionDialog>
  );
}
